import dayJs from 'dayjs'

export default {
  methods: {
    async exportExcel (DataType) {
      let param = Object.assign({}, this.query)
      const bizDate = dayJs(this.query.bizDate).format('YYYY-MM-DD')
      param.bizDate = param.bizDate && `${bizDate} 23:59:59`
      let beginDate = ''
      let endDate = ''
      if (this.query.date && this.query.date.length) {
        beginDate = dayJs(this.query.date[0]).format('YYYY-MM-DD')
        endDate = dayJs(this.query.date[1]).format('YYYY-MM-DD')
        param.beginDate = this.query.date[0] && `${beginDate} 00:00:00`
        param.endDate = this.query.date[1] && `${endDate} 23:59:59`
      }
      param.DataType = DataType

      let excelName = ''
      switch (DataType) {
        case 'RECEIPT':
          excelName = '交收通知单'
          break
        case 'PAYMENT':
          excelName = '暂扣款项表'
          break
        case 'TRANSACT':
          excelName = '办理表'
          break
        case 'LOAN':
          excelName = '日报表'
          break
      }

      const xmlRequest = new XMLHttpRequest()
      xmlRequest.open('POST', '/data-forward-server/count/exportTargetForm/downloadFile.magpie', true)
      xmlRequest.setRequestHeader('Content-type', 'application/json')
      param ? xmlRequest.send(JSON.stringify(param)) : xmlRequest.send()
      xmlRequest.responseType = 'blob'
      xmlRequest.onload = (oEvent) => {
        const content = xmlRequest.response
        const dateForm = param.bizDate ? bizDate : `${dayJs(beginDate).format('YYYYMMDD')}-${dayJs(endDate).format('YYYYMMDD')}${excelName}`
        const blob = new Blob([content])
        if (window.navigator.msSaveOrOpenBlob) { // 兼容IE
          let fileName = `${this.query.memberNumber}客户${dateForm}.xlsx`
          navigator.msSaveBlob(blob, fileName)
        } else {
          if (content.size) {
            const eLink = document.createElement('a')
            eLink.download = `${this.query.memberNumber}客户${dateForm}.xlsx`
            eLink.style.display = 'none'
            eLink.href = URL.createObjectURL(blob)
            document.body.appendChild(eLink)
            eLink.click()
            document.body.removeChild(eLink)
          } else {
            this.$message.error('暂无数据可导出或类型错误')
          }
        }
      }
    },
  }
}
